import PreauthRoutes from 'src/app/preAuth/preauth.routing'
import AdminRoutes from 'src/app/auth/admin/admin.routing'
import CommonRoutes from 'src/app/auth/common/common.routing'
import ClientRoutes from 'src/app/auth/client/client.routing'
import PartnerRoutes from 'src/app/auth/partner/partner.routing'
import PublicClientRoutes from './preAuth/@client/client.routing'

export default [
    PreauthRoutes,
    AdminRoutes,
    CommonRoutes,
    ClientRoutes,
    PartnerRoutes,
    PublicClientRoutes
]